import { Button } from "../../../components/ui/button";
import { SectionCard } from "../../../components/SectionCard";
import { navigate } from "../../../lib/router";
import { useLanguage } from "../../../contexts/LanguageContext";
import { settingsLabels } from "../labels";
import { MessageSquare } from "lucide-react";

export function WhatsappBanner() {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].whatsappBanner;
  return (
    <SectionCard 
      header={
        <div className="flex items-center gap-2">
          <MessageSquare className="h-3.5 w-3.5 text-[#25D366]" />
          {t.header}
        </div>
      }
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 p-6 rounded-2xl bg-emerald-50/50 border border-emerald-100/50">
        <div className="space-y-1">
          <p className="text-sm font-bold text-neutral-800">{lang === 'pt' ? 'Notificações Automáticas' : 'Automatic Notifications'}</p>
          <p className="text-xs text-neutral-500">{t.description}</p>
        </div>
        <Button 
          onClick={() => navigate("/app/settings/whatsapp")}
          className="bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold px-8"
        >
          {t.configure}
        </Button>
      </div>
    </SectionCard>
  );
}
